define([
	"dojo/_base/declare",
	"csi/html",
	"csi/image/_base",
	"csi/view/Widget",
	"dojo/text!./PageWidget.html",
	"csi/widget/Container",
	"csi/widget/SplitPane"
], function(declare, html, csiImage, Widget, template) {

	return declare(Widget, {
		templateString: template,
		bTitleblock: true,

		// extension points
		notesNode: null,
		snapshotNode: null,
		splitNode: null,
		titleBlockNode: null,

		/** @property {Object} notesParams - parameters for notes container */
		notesParams: null,

		/** @property {number} pageHeight - height of canvas page in pixels, which includes titleblock */
		pageHeight: 0,

		/** @property {string} snapshot - src for snapshot image */
		snapshot: "",

		/** @property {number} split - percentage (0-1) of page used by canvas */
		split: 0,

		/** @property {boolean} vertical - indicates if page is oriented vertically */
		vertical: false,

		/**
		 * Apply notes parameters to container
		 */
		postCreate: function() {
			this.inherited(arguments);
			this.notesNode.set(this.notesParams);
			$(this.splitNode.domNode).height(this.pageHeight);


			if (this.snapshot) {
				csiImage.create(null, this.snapshot, this.snapshotNode);
			} else {
				html.destroyElement(this.snapshotNode);
			}
		},

		/**
		 * Update canvas height based on height of given titleblock
		 * @param {DOMNode} [titleBlockNode]
		 */
		resizeWithTitleblock: function(titleBlockNode) {
			if (this.bTitleblock) {
				titleBlockNode = this.titleBlockNode;
			}

			if (titleBlockNode) {
				$(this.splitNode.domNode).height(this.pageHeight - $(titleBlockNode).height());
				this.splitNode.resize();
			}
		},

		/**
		 * Render titleblock if so configured
		 * @param {Context} ctx
		 * @param {Deferred[]} dfds
		 */
		_postViewDeferred: function(ctx, dfds) {
			var self = this;

			if (this.bTitleblock) {
				// the root node of the view should be the revision, even though this is a view of the DataSheetPage
				dfd = this._insertAndCreateView("TitleBlock", this.getViewNode(), this.titleBlockNode).then(function(view) {
					self.viewLayout = view;
				});
				dfds.push(dfd);
			} else {
				// remove this view's titleblock node
				$(this.titleBlockNode).remove();
				this.titleBlockNode = null;
			}
		}
	});
});